module.exports = __webpack_public_path__ + "img/interrogation.cee7ccd3.png";